import React from 'react';
import {i18n} from 'react-i18n';

const STYLES = {
	container: {
		padding: '30px 0 30px 0'
	},
	calcRow: {
		display: 'inline-block',
		width: '40%'
	},
	calcRowLeft: {
		margin: '0 1% 0 9%'
	},
	calcRowRight: {
		margin: '0 9% 0 1%'
	},
	calcLabel: {
		padding: '0 0 8px 5px'
	},
	inputCol: {
		position: 'relative'
	},
	input: {
		outlineOffset: '-1px'
	},
	inputLeft: {
		paddingRight: '100px'
	},
	inputRight: {
		paddingRight: '60px'
	},
	fromCode: {
		position: 'absolute',
		right: '1px',
		top: '1px',
		height: '40px',
		width: '90px',
		borderTop: 0,
		borderRight: 0,
		borderBottom: 0
	},
	toCode: {
		position: 'absolute',
		right: '15px',
		top: 0,
		lineHeight: '42px'
	},
	conversion: {
		textAlign: 'center',
		paddingTop: '30px'
	},
	disabled: {
		opacity: '0.5'
	}
};

const Calculator = React.createClass({
    propTypes: {
		availableCurrencies: React.PropTypes.array.isRequired,
		decimalPoint: React.PropTypes.string.isRequired,
		conversionRate: React.PropTypes.string.isRequired,
		fromAmount: React.PropTypes.string.isRequired,
		fromCode: React.PropTypes.string.isRequired,
		fromDisabled: React.PropTypes.bool.isRequired,
		toAmount: React.PropTypes.string.isRequired,
		toCode: React.PropTypes.string.isRequired,
		toDisabled: React.PropTypes.bool.isRequired,
		handleFromChange: React.PropTypes.func.isRequired,
		handleFromCurrencyChange: React.PropTypes.func.isRequired,
		handleToChange: React.PropTypes.func.isRequired
    },

	mixins: [i18n('guest/crossBorder')],

	validateAmount(ev, cb) {
		let val = ev.target.value;
		let rgx = /^[0-9]*[.|,]?[0-9]?[0-9]?$/;

		if (val === '.' || val === ',' || !val.match(rgx)) {
			return;
		}

		cb(val);
	},

	handleFromChange(ev) {
		this.validateAmount(ev, this.props.handleFromChange);
	},

	handleToChange(ev) {
		this.validateAmount(ev, this.props.handleToChange);
	},

	handleFromCurrencyChange(ev) {
		let val = ev.target.value;
		this.props.handleFromCurrencyChange(val);
	},

	getLocalizedAmount(amount) {
		return `${amount}`.replace(/[.|,]/i, this.props.decimalPoint);
	},

	render() {
		const placeholder = this.getLocalizedAmount('0.00');
		const fromAmount = this.getLocalizedAmount(this.props.fromAmount);
		const toAmount = this.getLocalizedAmount(this.props.toAmount);
		const conversionRate = `${this.getLocalizedAmount('1.00')} ${this.props.fromCode} = ${this.getLocalizedAmount(this.props.conversionRate)} ${this.props.toCode}`;

		return (<div className="col-xs-12 col-sm-12 col-md-12 donate-amount-calculator inputField" style={STYLES.container}>
			<div className="money_input">
				<div style={this.props.fromDisabled ? {...STYLES.calcRow, ...STYLES.calcRowLeft, ...STYLES.disabled} : {...STYLES.calcRow, ...STYLES.calcRowLeft}}>
					<div style={STYLES.calcLabel}>
						{this.i18n('label.youDonate')}
					</div>
					<div style={STYLES.inputCol}>
						<div className="vx_form-control vx_form-control_complex">
							<input type="text"
								value={fromAmount}
								onChange={this.handleFromChange}
								style={{...STYLES.input, ...STYLES.inputLeft}}
								disabled={this.props.fromDisabled}
								placeholder={placeholder}
							/>
						</div>
						<select
							value={this.props.fromCode}
							onChange={this.handleFromCurrencyChange}
							style={STYLES.fromCode}
						>
							{this.props.availableCurrencies.map((c) =>
								<option key={c}>{c}</option>
							)}
						</select>
					</div>
				</div>
				<div style={this.props.toDisabled ? {...STYLES.calcRow, ...STYLES.calcRowRight, ...STYLES.disabled} : {...STYLES.calcRow, ...STYLES.calcRowRight}}>
					<div style={STYLES.calcLabel}>
						{this.i18n('label.charityGet')}
					</div>
					<div style={STYLES.inputCol}>
						<div className="vx_form-control vx_form-control_complex">
							<input type="text"
								value={toAmount}
								onChange={this.handleToChange}
								style={{...STYLES.input, ...STYLES.inputRight}}
								disabled={this.props.toDisabled}
								placeholder={placeholder}
							/>
						</div>
						<span style={STYLES.toCode}>{this.props.toCode}</span>
					</div>
				</div>
			</div>

			{this.props.conversionRate &&
				<div style={this.props.fromDisabled || this.props.toDisabled ? {...STYLES.conversion, ...STYLES.disabled} : STYLES.conversion}>
					{this.i18n('label.conversion')} {conversionRate}
				</div>
			}
		</div>);
	}
});

export default Calculator;



// WEBPACK FOOTER //
// ./common/calculator.js